/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserInvitationApiModel { 
    loginEmail: string;
    password: string;
    fullName: string;
    invitationCode: string;
}

